import React from 'react';
import { ReactComponent as FableButterfly } from '../images/fable-butterfly-outline.svg';

export default function FableButterflyIcon(props: React.SVGProps<SVGSVGElement>) {
  return <FableButterfly width={24} height={24} color="#fff" fill="currentColor" stroke="none" aria-hidden="true" focusable="false" {...props} />;
}
